export const ListingNavigationCardVariant = {
  Horizontal: 'horizontal',
  Vertical: 'vertical',
};

export const ListingNavigationCardProperty = {
  ImageSource: 'imageSource',
  Title: 'title',
  Description: 'description',
  ButtonLink: 'buttonLink',
  ButtonFill: 'buttonFill',
  ButtonName: 'buttonName',
  Variant: 'variant',
  Origin: 'origin',
};
